import request from "@/utils/request.js";

/**
 * 取消订单
 * @param params
 * @returns {AxiosPromise}
 */
export function cancelPayOrder(params) {
  return request({
    url: "/tradeService/api/app/orderCommodity/cancelPayOrder",
    method: "post",
    data: params
  });
}

/**
 * 删除订单
 * @param params
 * @returns {AxiosPromise}
 */
export function removeCourseCommodityOrder(params) {
  return request({
    url: "/tradeService/api/app/orderCommodity/removeCourseCommodityOrder",
    method: "post",
    data: params
  });
}

/**
 * 个人中心-商品类订单详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getOrderCommodityDetailByUser(params) {
  return request({
    url: "/tradeService/api/app/orderCommodity/getOrderCommodityDetailByUser",
    method: "post",
    data: params
  });
}

/**
 * 个人中心-商品类订单列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getOrderCommodityListByUser(params) {
  return request({
    url: "/tradeService/api/app/orderCommodity/getOrderCommodityListByUser",
    method: "post",
    data: params
  });
}
